var App = App || {};

App.StackedTable = (function ($) {
    'use strict';

    var $tables;

    function init() {

        $tables = $('.table-stacked');

        $tables.each(function () {
            if (typeof $.fn.stackcolumns === 'function') {
                console.log("test stacked columns");
                $(this).stackcolumns({ myClass: 'table table--stacked table-stacked' });
            }
        });
    }

    return {
        init: init
    };
})(jQuery);

$(function () {
    App.StackedTable.init();
});